import {Component, Input} from '@angular/core';
import {ApiError} from "@api/api-error";

@Component({
  selector: 'iw-shop-forms-error',
  templateUrl: './form-error.component.html',
  styleUrls: ['./form-error.component.scss']
})
export class FormErrorComponent {

  @Input() apiError!: ApiError | undefined;


  constructor() {


  }

}
